import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  columns,
  formFields,
  otherFields,
  initObject,
  filterFields,
  filterInitialValues,
  ObjectEditSchema,
  placColumns,
  buildingColumns,
  newprepareFilter,
  newfilterFields,
  newfilterInitialValues,
  rowFormatter,
  editRowFormatter
} from './AuditFormResultUtils';
import { AuditFormListEditPage } from './AuditFormListEditPage';


const PlaceAuditFormResultPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.placeAuditFormList }),
    shallowEqual
  );

  const { resultState } = useSelector(
    (state) => ({ resultState: state.placeAuditFormResults }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/resultForms")) {
    const temp = menuList.find(q => q.url == "/resultForms")
    isFullAccess = temp.isFullAccess;
  }


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          {/* {
          <Redirect
            exact={true}
            from="/formList"
            to="/formList/placeFormList"
          />
        }
        {
          <Redirect
            // exact={true}
            from="/formList/buildings"
            to="/formList/placeFormList"
          />
        }
        {
          <Redirect
            // exact={true}
            from="/formList/floors"
            to="/formList/placeFormList"
          />
        }
        {
          <Redirect
            // exact={true}
            from="/formList/rooms"
            to="/formList/placeFormList"
          />
        } */}

          <ContentRoute
            path="/resultForms/placeFormList/:id/edit"
            render={props =>
              <AuditFormListEditPage
                {...props}
                isFullAccess={isFullAccess}
                basePath="/resultForms/placeFormList"
                api="api/AuditFormResult"
                methodName="GetPlacesResultByFormListId"
                updateMethodName="UpdatePlaceResultStatus"
                exportfuncName="GetExportPlacesResultByFormListId"
                currentState={resultState}
                listState={currentState}
                initObject={initObject}
                columns={columns}
                formFields={formFields}
                otherFields={otherFields}
                ObjectEditSchema={ObjectEditSchema}
                prepareFilter={newprepareFilter}
                filterFields={filterFields}
                filterInitialValues={filterInitialValues}
                // otherTabs={otherTabs}
                rowFormatter={editRowFormatter}
              />
            }
          />

          <ContentRoute
            path="/resultForms/placeFormList"
            render={props =>
              <ObjectsPage
                getFunctionName="GetPlaces"
                filterByShowButton={false}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/resultForms/placeFormList"
                api="api/AuditFormList"
                currentState={currentState}
                columns={placColumns}
                prepareFilter={newprepareFilter}
                filterFields={newfilterFields}
                filterInitialValues={newfilterInitialValues}
                // hideSelected={true}
                checkActive={true}
                rowFormatter={rowFormatter}
                showAuditResultForm={true}
                haveSaveAllButton={true}
              />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default PlaceAuditFormResultPage



